import { useLocalization } from "@fluent/react";
import { Checkbox } from "@narmi/design_system";

import styles from "../AccountsModule.module.scss";

import AccountsList from "./AccountsList";

import type { ViewMode } from "../useViewPreference";
import type { AccountClassType } from "./types";
import type { AddAccountMode } from "../../../../components/settings/linked_accounts/types";

type HiddenAccountsSectionProps = {
  accounts: AccountClassType[];
  view: ViewMode;
  showHiddenBalance?: boolean;
  onShowHiddenBalanceChange?: (v: boolean) => void;
  onVerify?: (account: AccountClassType) => void;
  onTriggerInstantVerification?: (mode: AddAccountMode) => void;
};

const HiddenAccountsSection = ({
  accounts,
  view,
  showHiddenBalance,
  onShowHiddenBalanceChange,
  onVerify,
  onTriggerInstantVerification,
}: HiddenAccountsSectionProps) => {
  const { l10n } = useLocalization();

  if (accounts.length === 0) {
    return null;
  }

  return (
    <div className={styles.hiddenSection}>
      <div className={styles.hiddenSectionTitle}>
        {l10n.getString("dashboard-redesign-accounts-hidden-title")}
      </div>
      <AccountsList
        accounts={accounts}
        view={view}
        isEditing
        isHidden
        onVerify={onVerify}
        onTriggerInstantVerification={onTriggerInstantVerification}
      />
      {onShowHiddenBalanceChange && (
        <div className={styles.hiddenSectionCheckbox}>
          <Checkbox
            checked={!!showHiddenBalance}
            onChange={() => onShowHiddenBalanceChange(!showHiddenBalance)}
            label={l10n.getString(
              "dashboard-redesign-accounts-include-hidden-balance"
            )}
          />
        </div>
      )}
    </div>
  );
};

export default HiddenAccountsSection;
